import { FadeUp, SlideTitle, SlideConclusion } from "../Deck";

const STEPS = [
  { n: "01", h: "Order", p: "The doctor issues a clinician order." },
  { n: "02", h: "Match", p: "A credentialed physiotherapist is assigned." },
  {
    n: "03",
    h: "Schedule",
    p: "At home first; remote, hybrid or clinic as needed.",
  },
  {
    n: "04",
    h: "Treat",
    p: "Every session documented in PranIQ Pro.",
  },
  { n: "05", h: "Report", p: "Outcomes return to the doctor." },
];

export default function Slide04How() {
  return (
    <div>
      <SlideTitle>
        One order, <em className="italic text-gold">five steps</em>
      </SlideTitle>
      <div className="relative mt-14">
        <div
          className="absolute left-0 right-0 top-7 hidden border-t border-ink/15 lg:block"
          aria-hidden="true"
        />
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-6">
          {STEPS.map((s, i) => (
            <FadeUp key={s.n} delay={0.1 + i * 0.09} className="relative">
              <div className="flex h-14 w-14 items-center justify-center rounded-full border border-ink/15 bg-bone font-display text-lg text-teal">
                {s.n}
              </div>
              <h3 className="mt-5 text-lg font-semibold tracking-tight">
                {s.h}
              </h3>
              <p className="mt-2 max-w-[220px] text-sm leading-relaxed text-mut">
                {s.p}
              </p>
            </FadeUp>
          ))}
        </div>
      </div>
      <SlideConclusion>Every order ends in a report.</SlideConclusion>
    </div>
  );
}
